var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeciality9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c,.d{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}.c{stroke:#208ce1;}.d{stroke:#e5ebf4;}.e{fill:#bccbe3;opacity:0.389;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 50,
    transform: "translate(-2861 -3943)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(2861 3943)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3450.706 -5068.667)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M9.431,16.124c.029,1.043.275,3.552-.888,5.37C6.673,24.416,2.63,30.987,1.562,32.68A3.749,3.749,0,0,0,.97,34.346c-.091.992.222,2.294,2.239,2.838,3.375.908,3.936,2.876,3.683,4.258s-1.129,3.663,1.156,4.764",
    transform: "translate(591.081 1117.176)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M27.906,107.137s-1.48,1.649-5.115,1.575a1.864,1.864,0,0,0-1.62,2.885l.024.038a6.7,6.7,0,0,1,.468.859,5.239,5.239,0,0,1,.275,3.51c-.375,1.469-.271,4.118,5.325,4.118h3.3",
    transform: "translate(577.397 1052.255)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M25.68.953s-5.958,7.358,13.6,7.764a16.191,16.191,0,0,1,5.174.805c2.416.9,4.737,2.754,2.958,6.577",
    transform: "translate(573.938 1127.608)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M34.561,96.618A65.054,65.054,0,0,1,33.23,81.826a5.619,5.619,0,0,0-5.25-5.636l-5.092-.339s-5.2-.078-6.67-3.47",
    transform: "translate(580.587 1076.156)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M46.395,89.654c-1.6-4-1.689-9.1-1.682-13.657A11.483,11.483,0,0,0,33.206,64.541h-3.12s-3.856.064-4.467-2.29",
    transform: "translate(573.437 1083.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M17.091,73.746a.985.985,0,0,1,0-.69,7.727,7.727,0,0,0,.142-3.189,11.13,11.13,0,0,0,6.35,4.564h-3.3c-2.092,0-2.984-.433-3.184-.688",
    transform: "translate(583.838 1095.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M109.953,35.735s1.138-7.651,7-7.651c6.342,0,7.95,9.561,5.749,14.9-3.029,7.36-7.853,6.916-7.853,6.916a4.3,4.3,0,0,1-4.34-2.656",
    transform: "translate(513.737 1108.151)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M119.621,44.036A7.537,7.537,0,0,1,116.6,41.7a7.246,7.246,0,0,0-.315.8,3.046,3.046,0,0,0,.364,2.578c.32.508.475,1.32-.814,2.157a13.771,13.771,0,0,0,.339,2.809,2.773,2.773,0,0,0,2.667,2.175h.191l.029,0h.011c.415,0,3.617-.184,5.9-5.727,1.3-3.169.97-7.826-.746-10.384A3.711,3.711,0,0,0,121,34.242a3.78,3.78,0,0,0-3.819,3.936,4.575,4.575,0,0,0,2.745,4.023",
    transform: "translate(509.691 1103.867)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeciality9);
export default __webpack_public_path__ + "static/media/speciality9.147783670113e3942facb3ef7b68b993.svg";
export { ForwardRef as ReactComponent };